import React, { lazy, Suspense } from "react";
import SEOHead from "@/components/SEOHead";
import SchemaMarkup from "@/components/SchemaMarkup";
import Hero from "@/components/Hero";
import LerchPlusSection from "@/components/LerchPlusSection";
import IntroSection from "@/components/IntroSection";
import SuitesGridSection from "@/components/SuitesGridSection";
import WellnessSection from "@/components/WellnessSection";
import ErlebnisseSection from "@/components/ErlebnisseSection";
// Poster liegt bewusst in /public: so kann es im HTML vorab per <link rel="preload">
// angefordert werden (LCP-Bild ist damit schon vor dem JS-Bundle entdeckbar).
const heroPlaceholder = "/hero/hero-placeholder-1280.webp";
import heroVideo from "@/assets/hero/hero-startseite-v2.mp4.asset.json";
import heroVideoMobile from "@/assets/hero/hero-startseite-mobile-hq.mp4.asset.json";
import { useLocale } from "@/contexts/LocaleContext";

const InstagramBewertungenSection = lazy(() => import("@/components/InstagramBewertungenSection"));

const Index: React.FC = () => {
  const { t } = useLocale();
  const headline = t("home.intro.headline");
  const subline = t("home.intro.subline");

  return (
    <>
      <SEOHead title="Ferienwohnungen Kappl | stilvolle Apartments | Urlaub im Paznaun" rawTitle description={subline} />
      <SchemaMarkup type="WebSite" data={{ name: headline }} />
      <SchemaMarkup type="WebPage" data={{ name: headline }} />

      <Hero
        videoSrc={heroVideo.url}
        videoSrcMobile={heroVideoMobile.url}
        posterSrc={heroPlaceholder}
        videoId="home.hero.video"
      />

      <div id="apartments-in-kappl" />

      <IntroSection />

      <SuitesGridSection />

      <LerchPlusSection />

      <WellnessSection />

      <ErlebnisseSection />

      <Suspense fallback={null}>
        <InstagramBewertungenSection showInstagram={true} />
      </Suspense>
    </>
  );
};

export default Index;

